export default __webpack_public_path__ + "static/media/sld_croptop.55417f6a.jpg";